import { cn } from "@/lib/utils";

export type EmptyStateProps = {
  onClick?: () => void;
  className?: string;
  children: React.ReactNode | React.ReactNode[];
}

export function EmptyState({ onClick, className, children }: EmptyStateProps) {
  return (
    <button className={cn(
      "relative block w-full rounded-lg border-2 border-dashed border-gray-300 p-12 text-center focus:outline-none",
      !onClick && 'cursor-default',
      onClick && 'hover:border-gray-400',
      className
    )}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
